import React from 'react';
import { GoalItemCard } from 'shared/components/ui/goal-item-card';
import {
  SortableContainer,
  SortableContainerProps,
} from 'shared/components/ui/sortable-container';
import { DraggableOptions } from 'shared/types/draggable-types';
import { Goal } from 'shared/types/goal';
import { goalInboxID } from 'shared/types/orderable-section';

export type GoalCardProps = Omit<
  React.ComponentProps<typeof GoalItemCard>,
  'goal'
> & {
  goal: Goal;
  hasDnd?: boolean;
  preventDnd?: boolean;
  children?: React.ReactNode;
};

const allDraggableOptions = Object.values(DraggableOptions);

export const GoalCard: React.FC<GoalCardProps> = ({
  goal,
  goals,
  hasDnd,
  preventDnd,
  children,
  ...rest
}) => {
  const Container = hasDnd ? SortableContainer : React.Fragment;
  const containerProps = (
    hasDnd
      ? {
          id: goal.id,
          type: DraggableOptions.Goal,
          cantDrag: goal.id === goalInboxID,
          cantInteractWithTypes: preventDnd
            ? allDraggableOptions
            : [DraggableOptions.LifeArea],
        }
      : {}
  ) as SortableContainerProps;

  return (
    <Container {...containerProps}>
      <GoalItemCard goal={goal} goals={goals} {...rest} />
      {children}
    </Container>
  );
};
